//开发服
module.exports = {
    baseUrl: 'https://test.cleverplanting.com/',
    reviewBaseUrl: 'http://test.base.cleverplanting.com',
}
